var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorinfo"},[_c('div',{staticClass:"authoesummary"},[_c('p',[_vm._v("作者")]),_vm._v(" "),_c('div',{staticClass:"userhead",staticStyle:{"margin":"10px"}},[_c('router-link',{attrs:{"to":{
                name:'user_info',
                params:{
                    name:_vm.userinfo.loginname
                }
                }}},[_c('img',{attrs:{"src":_vm.userinfo.avatar_url,"alt":""}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{
                name:'user_info',
                params:{
                    name:_vm.userinfo.loginname
                }
                }}},[_c('span',{staticClass:"loginname"},[_vm._v(_vm._s(_vm.userinfo.loginname))])])],1),_vm._v(" "),_c('p',{staticClass:"score"},[_vm._v("积分："+_vm._s(_vm.userinfo.score))])]),_vm._v(" "),_c('div',{staticClass:"recent_replies"},[_c('p',[_vm._v("作者最近主题")]),_vm._v(" "),_c('ul',_vm._l((_vm.topiccount),function(item){return _c('li',[_c('router-link',{attrs:{"to":{
                    name:'post_content',
                    params:{
                        id: item.id,
                        name: item.author.loginname
                    }
                }}},[_vm._v("\n                    "+_vm._s(item.title)+"\n                ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"recent_topics"},[_c('p',[_vm._v("作者最近回复")]),_vm._v(" "),_c('ul',_vm._l((_vm.repliescount),function(item){return _c('li',[_c('router-link',{attrs:{"to":{
                    name:'post_content',
                    params:{
                        id: item.id,
                        name: item.author.loginname
                    }
                }}},[_vm._v("\n                    "+_vm._s(item.title)+"\n                ")])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16f462d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideBar.vue
// module id = null
// module chunks = 